import { createBrowserRouter } from "react-router-dom"

import Layout from "../layout/main/Layout"
import ErrorPage from "../pages/ErrorPage"
import HomePage from "../pages/HomePage"
import { Paths } from "./paths"
import ProjectsPage from "../pages/ProjectsPage"

const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        path: Paths.home,
        element: <HomePage />,
      },
      {
        path: Paths.projects + "/*",
        element: <ProjectsPage />,
      },
    ],
  },
  {
    path: "*",
    element: <ErrorPage />,
  },
])

export default router
